import styled, { css } from "styled-components";

interface InputGroupStyleProps {
  $direction: "column" | "row";
  $gridColumn?: string | undefined;
}

export const InputGroup = styled.div<InputGroupStyleProps>`
  gap: 4px;
  display: ${(props) => (props.$direction === "column" ? "flex" : "grid")};

  ${(props) =>
    props.$gridColumn &&
    css`
      grid-template-columns: ${props.$gridColumn};

      button {
        margin-top: 19px;
      }

      & > div:nth-child(2) {
        margin-top: 19px;
      }
    `}
`;
